import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import clienteAxios from "../config/clienteAxios";

const CorralonesFilterContext = createContext();

const CorralonesFilterProvider = ({ children }) => {
  const [corralonesFilter, setCorralonesFilter] = useState(null);

  const getAllCorralonesFilter = async () => {
    try {
      const { data } = await clienteAxios("corralonesFilter");
      return data?.allCorralonesToFilter
    } catch (error) {
      console.log(error);
    }
  };

  const createCorralonFilter= async (corralon) => {
    const token = JSON.parse(localStorage.getItem("Usuario")).token;
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/corralonesFilter`,
        data: corralon,   
        headers: {
          authorization: token,
        },
        responseType: "json",
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const editCorralonFilter = async (corralonesFilterEdit) => {
    try {
      const { data } = await clienteAxios.put(`corralonesFilter`, corralonesFilterEdit);
      setCorralonesFilter(corralonesFilterEdit)
      toast.success("Se actualizó Corralones");
    } catch (error) {
      toast.error("Error al actualizar Corralones");
    }
  };

  return (
    <CorralonesFilterContext.Provider
      value={{
        corralonesFilter,
        setCorralonesFilter,
        createCorralonFilter,
        editCorralonFilter,
        getAllCorralonesFilter
      }}
    >
      {children}
    </CorralonesFilterContext.Provider>
  );
};

export { CorralonesFilterProvider };

export default CorralonesFilterContext;